module.exports = __webpack_public_path__ + "media/img/uplatnica-b23b9e90.gif";